import {muiTheme} from './mui.theme';

export const borderGeneral = {
  borderRadius: muiTheme.spacing(1),
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: muiTheme.palette.divider,
};
